module.exports = __webpack_public_path__ + "img/medtronic_capnostream-35.bec58a18.png";